module.exports = __webpack_public_path__ + "img/corrugatedBg.80d68bd8.png";